<template>
	<div class="service">
		<div class="serve-content">
<!-- 			<div class="server-item" v-if="imei!=''">
				<div class="train-title">放松训练</div>
				<div class="train-content">
					<div class="train" @click="trainDetails('正念冥想')">
						<div class="train-pic">
							<img src="../assets/images/train1.jpg" alt="">
							<div class="train-tag back-a">舒压</div>
						</div>
						<div class="train-name">正念冥想</div>
					</div>
					<div class="train" @click="trainDetails('美人技术')">
						<div class="train-pic">
							<img src="../assets/images/card4.png" alt="">
							<div class="train-tag back-b">情绪缓解</div>
						</div>
						<div class="train-name">美人技术</div>
					</div>
					<div class="train" @click="freedomTrain('自由练习')">
						<div class="train-pic">
							<img src="../assets/images/card3.png" alt="">
							<div class="train-tag back-c">自由练习</div>
						</div>
						<div class="train-name">自由练习</div>
					</div>
				</div>
			</div> -->

			<div class="server-item" v-if="imei!='' && trainData.length">
				<div class="test-title">
					<div class="title-text">减压放松</div>
					<div class="test-more" @click="meditaList">
						<div class="more-text">查看更多</div>
						<img src="../assets/images/history_more.png" alt="">
					</div>
				</div>
				<div class="train-content">
					<div v-for="(item,index) in this.trainData" :key="index" class="train"
						@click="toTrain(item)">
						<div class="train-pic">
							<img :src="item.icon_url" alt="">
						</div>
						<div class="train-name">{{item.title}}</div>
					</div>
				</div>
			</div>

			<div class="server-item" v-if="imei!='' && noiseData.length">
				<div class="test-title">
					<div class="title-text">白噪音</div>
					<div class="test-more" @click="noiseList">
						<div class="more-text">查看更多</div>
						<img src="../assets/images/history_more.png" alt="">
					</div>
				</div>
				<div class="train-content">
					<div v-for="(item,index) in this.noiseData" :key="index" class="train"
						@click="toTrain(item)">
						<div class="train-pic">
							<img :src="item.icon_url" alt="">
						</div>
						<div class="train-name">{{item.title}}</div>
					</div>
				</div>
			</div>
			
			<div class="server-item" v-if="imei!=''">
				<div class="test-title">
					<div class="title-text">心理测评</div>
					<div class="test-more" @click="testList">
						<div class="more-text">查看更多</div>
						<img src="../assets/images/history_more.png" alt="">
					</div>
				</div>
				<div class="train-content">
					<div class="train" @click="toTest(92)">
						<div class="train-pic">
							<img src="../assets/images/knowledge-d.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="train-name">大五人格</div>
					</div>
					<div class="train" @click="toTest(119)">
						<div class="train-pic">
							<img src="../assets/images/knowledge-c.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="train-name">PHQ-9</div>
					</div>
					<div class="train" @click="toTest(117)">
						<div class="train-pic">
							<img src="../assets/images/knowledge-b.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="train-name">状态焦虑量表</div>
					</div>
				</div>
				
			</div>
			
<!-- 			<div class="server-item" v-if="imei!=''">
				<div class="test-title">
					<div class="title-text">心理测评</div>
					<div class="test-more" @click="testList">
						<div class="more-text">查看更多</div>
						<img src="../assets/images/history_more.png" alt="">
					</div>
				</div>
				<div class="test-content">
					<div class="test" @click="toTest(92)">
						<div class="test-pic">
							<img src="../assets/images/knowledge-d.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="test-name">大五人格</div>
					</div>
					<div class="test" @click="toTest(119)">
						<div class="test-pic">
							<img src="../assets/images/knowledge-c.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="test-name">PHQ-9</div>
					</div>
					<div class="test" @click="toTest(117)">
						<div class="test-pic">
							<img src="../assets/images/knowledge-b.png" alt="">
							<div class="test-tag">测评</div>
						</div>
						<div class="test-name">状态焦虑量表</div>
					</div>
				</div>
			</div> -->
		</div>
		<Tab name="service"></Tab>
	</div>
</template>
<script>
	import Tab from '../components/bot-tab.vue'
	import {
		service_resource
	} from '../api/server'
	export default {
		components: {
			Tab,
		},
		data() {
			return {
				loginPhone: '',
				imei: '',
				nonceStr: '',
				signature: '',
				timestamp: '',
				trainData: [],
				noiseData: []
			};
		},
		computed: {},
		methods: {
			noiseList(){
				this.$router.push({
					path: '/noise-list',
				})
			},
			meditaList(){
				this.$router.push({
					path: '/meditation-list',
				})
			},
			toTrain(data) {
				this.$router.push({
					path: '/meditation-audio',
					query: data
				})
			},
			freedomTrain() {
				this.$router.push({
					path: '/freedomtrain',
				})
			},
			tomp() {
				console.log("tomp");
			},
			toTest(id) {
				this.$router.push({
					path: '/test-main',
					query: {
						id: id
					}
				})
			},
			trainDetails(type) {
				this.$router.push({
					path: '/train-main',
					query: {
						train: type
					}
				})
			},
			testList() {
				this.$router.push('/test-list')
			},
			knowledgeMore() {
				this.$router.push('/knowledge-more')
			},
			knowledgeA() {
				this.$router.push('/knowledge-a')
			},
			knowledgeB() {
				this.$router.push('/knowledge-b')
			},
			knowledgeC() {
				this.$router.push('/knowledge-c')
			},
		},
		mounted() {
			let imei = localStorage.getItem('imei')
			if (imei) {
				this.imei = imei
			}
		},
		created() {
			let phone = localStorage.getItem('phone')
			if (phone) {
				this.loginPhone = phone
			} else {
				this.$router.push('/login')
			}
			let imei = localStorage.getItem('imei')
			if (imei) {
				this.imei = imei
			}
			if(!this.$store.state.trainList.length){
				service_resource('{"recommend_type":1,"recommend_size":3}', 'heartide.bixin.audio.recommend').then(res => {
					if (res.code == '0') {
						this.$store.commit('setTrain', JSON.parse(res.data))
						this.trainData = this.$store.state.trainList;
					}
				}).catch(e => {
					console.log(e);
				})
			}else{
				this.trainData = this.$store.state.trainList;
			}
			
			if(!this.$store.state.noiseList.length){
				service_resource('{"recommend_type":2,"recommend_size":3}', 'heartide.bixin.audio.recommend').then(res => {
					if (res.code == '0') {
						this.$store.commit('setNoise', JSON.parse(res.data))
						this.noiseData = this.$store.state.noiseList;
					}
				}).catch(e => {
					console.log(e);
				})
			}else{
				this.noiseData = this.$store.state.noiseList;
			}

		},
	};
</script>
<style lang='less' scoped>
	.service {
		padding: 16px;
		padding-bottom: 60px;
	}

	.server-item {
		border-radius: 10px;
		background-color: #fff;
		margin-bottom: 10px;
	}

	.train-title {
		height: 42px;
		line-height: 42px;
		background-color: #FBFCFC;
		border-radius: 10px 10px 0px 0px;
		font-size: 18px;
		font-weight: 700;
		color: #333;
		padding: 0px 12px;
	}

	.train-content {
		padding: 12px;
		display: flex;
		justify-content: space-between;
	}

	.train {
		width: 32%;
	}

	.train-pic {
		position: relative;
		border-radius: 10px;
	}

	.train-pic img {
		display: block;
		width: 100%;
		height: 100px;
		border-radius: 10px;
	}

	.train-tag {
		position: absolute;
		right: 0px;
		top: 0px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		padding: 0px 7px;
		border-radius: 0px 10px 0px 10px;
	}

	.back-a {
		background-color: #01D6D6;
	}

	.back-b {
		background-color: #A058EA;
	}

	.back-c {
		background-color: #E7A902;
	}

	.train-name {
		padding-top: 8px;
		height: 18px;
		line-height: 18px;
		text-align: center;
		font-size: 14px;
		color: #333;
		overflow: hidden;
	}

	.test-title {
		height: 42px;
		background-color: #FBFCFC;
		border-radius: 10px 10px 0px 0px;
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
	}

	.title-text {
		height: 42px;
		line-height: 42px;
		font-size: 18px;
		font-weight: 700;
		color: #333;
	}

	.test-more {
		display: flex;
		justify-content: flex-start;
		height: 16px;
		margin-top: 13px;
	}

	.more-text {
		height: 16px;
		line-height: 16px;
		font-size: 14px;
		color: #333;
		margin-right: 2px;
	}

	.test-more img {
		display: block;
		height: 16px;
	}

	.test-content {
		display: flex;
		justify-content: space-between;
		padding: 12px;
	}

	.test {
		width: 80px;
	}

	.test-pic {
		height: 80px;
		width: 80px;
		position: relative;
		border-radius: 10px;
	}

	.test-pic img {
		display: block;
		width: 80px;
		height: 80px;
		border-radius: 10px;
	}

	.test-tag {
		position: absolute;
		right: 0px;
		top: 0px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		padding: 0px 7px;
		border-radius: 0px 10px 0px 10px;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.test-name {
		padding-top: 8px;
		line-height: 18px;
		font-size: 14px;
		color: #333;
		text-align: center;
	}

	.consult-title {
		height: 42px;
		background-color: #FBFCFC;
		border-radius: 10px 10px 0px 0px;
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
	}

	.consult-text {
		height: 42px;
		line-height: 42px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.consult-more {
		display: flex;
		justify-content: flex-start;
		height: 16px;
		margin-top: 13px;
		position: relative;
	}

	.consult-more img {
		display: block;
		height: 16px;
	}

	.consult-content {
		display: flex;
		justify-content: space-between;
		padding: 12px;
	}

	.consult-pic {
		width: 30%;
		height: 100px;
		display: block;
		border-radius: 10px;
	}

	.counselor {
		width: 68%;
	}

	.counselor-head {
		height: 24px;
		display: flex;
		justify-content: space-between;
	}

	.counselor-name {
		height: 24px;
		line-height: 24px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.experience {
		margin-top: 3px;
		height: 18px;
		border-radius: 9px;
		background-color: #F3F3F3;
		line-height: 18px;
		text-align: center;
		padding: 0px 9px;
		font-size: 12px;
		color: #666666;
	}

	.order {
		height: 24px;
		line-height: 24px;
		text-align: center;
		border-radius: 12px;
		padding: 0px 8px;
		background-color: #01D6D6;
		font-size: 12px;
		color: #fff;
		position: relative;
	}

	.field {
		margin-top: 9px;
		height: 12px;
		line-height: 12px;
		font-size: 12px;
		color: #666666;
		margin-bottom: 18px;
	}

	.counselor-info {
		height: 40px;
		line-height: 20px;
		color: #999999;
		font-size: 14px;
		overflow: hidden;
	}

	.knowledge-title {
		height: 42px;
		background-color: #FBFCFC;
		border-radius: 10px 10px 0px 0px;
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
	}

	.knowledge-text {
		height: 42px;
		line-height: 42px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.knowledge-more {
		display: flex;
		justify-content: flex-start;
		height: 16px;
		margin-top: 13px;
	}

	.knowledge-more img {
		display: block;
		height: 16px;
	}

	.knowledge-content {
		display: flex;
		justify-content: space-between;
		padding: 12px;
	}

	.knowledge {
		width: 80px;
	}

	.knowledge-pic {
		height: 80px;
		width: 80px;
		position: relative;
		border-radius: 10px;
	}

	.knowledge-pic img {
		height: 80px;
		width: 80px;
		border-radius: 10px;
		display: block;
	}

	.knowledge-tag {
		position: absolute;
		right: 0px;
		top: 0px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		padding: 0px 7px;
		border-radius: 0px 10px 0px 10px;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.knowledge-name {
		padding-top: 8px;
		line-height: 18px;
		font-size: 14px;
		color: #333;
		text-align: center;
	}
</style>